import type { TripStatusType, TTripTaskRes, TUpdateTripTaskReq } from 'api/swagger';

export interface ITripEditTaskModalProps {
  open: boolean;
  onCancel: () => void;
  tripTask: TTripTaskRes;
  tripStatus: TripStatusType;
  onSubmit: (payload: TUpdateTripTaskReq) => void;
  isPending: boolean;
}

export enum EStepKey {
  taskType = 'taskType',
  details = 'details',
}
